/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Hash } from './hash';


export interface RT1GenerateRequest { 
    pkcs7: string;
    hash: Hash;
    revision: number;
    'zb-token': string;
}

